import { Code, type ConnectError } from '@connectrpc/connect'
import type { TFunction } from 'i18next'

import type { AppErrorInfoResolution } from '~/libs/appErrorInfo'
import type { GenerationSiteFormValues } from '~/pages/AdminPlantUnitMaster/models/siteForm'

/** 発電所 (サイト) の登録・更新で、code ごとに引く既定の文言 (`useCrudModalForm.customErrorKeys`)。 */
export const GENERATION_SITE_SAVE_ERROR_KEYS: Partial<Record<Code, string>> = {
  [Code.Aborted]: 'page:adminPlantUnitMaster.site.serverError.aborted',
  [Code.NotFound]: 'page:adminPlantUnitMaster.site.serverError.notFound',
  [Code.InvalidArgument]:
    'page:adminPlantUnitMaster.site.serverError.invalidArgument',
}

/** 削除・取得の失敗文言の prefix (`mapMasterDeleteError` が aborted / failedPrecondition / notFound / unknown を引く)。 */
export const GENERATION_SITE_ERROR_KEY_PREFIX =
  'page:adminPlantUnitMaster.site.serverError'

export const GENERATION_SITE_UNKNOWN_ERROR_KEY =
  'page:adminPlantUnitMaster.site.serverError.unknown'

/**
 * 名称の重複 (AlreadyExists) は名称欄の脇に「発電所「<名称>」は既に登録されています」を出す
 * (`useCrudModalForm.resolveDetailedError`)。それ以外は undefined を返し、code ベースの既定文言に任せる。
 * この RPC の AlreadyExists は名称の重複だけ (他の一意制約を持たない)。
 */
export function resolveGenerationSiteSaveError(
  err: ConnectError,
  t: TFunction,
  values: GenerationSiteFormValues,
): AppErrorInfoResolution | undefined {
  if (err.code !== Code.AlreadyExists) {
    return undefined
  }
  return {
    kind: 'field',
    field: 'siteName',
    message: t('page:adminPlantUnitMaster.site.serverError.duplicateName', {
      name: values.siteName,
    }),
  }
}
